export default "__VITE_ASSET__yCtAHNhp__"